var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeaderBackIcon = function SvgHeaderBackIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4.481,
    height: 7.765,
    viewBox: "0 0 4.481 7.765",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.481 7.765) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.431,0,4.28.425a.634.634,0,0,1,.534.541.375.375,0,0,1-.428.436L.537.98A.634.634,0,0,1,0,.439.375.375,0,0,1,.431,0Z",
    transform: "translate(0.958 0) rotate(43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.537.425,4.385,0a.375.375,0,0,1,.428.436h0A.634.634,0,0,1,4.28.98L.431,1.4A.375.375,0,0,1,0,.967H0A.634.634,0,0,1,.537.425Z",
    transform: "translate(0 6.737) rotate(-43)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeaderBackIcon, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0LjQ4MSIgaGVpZ2h0PSI3Ljc2NSIgdmlld0JveD0iMCAwIDQuNDgxIDcuNzY1Ij4KICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0LjQ4MSA3Ljc2NSkgcm90YXRlKDE4MCkiPgogICAgPHBhdGggZD0iTS40MzEsMCw0LjI4LjQyNWEuNjM0LjYzNCwwLDAsMSwuNTM0LjU0MS4zNzUuMzc1LDAsMCwxLS40MjguNDM2TC41MzcuOThBLjYzNC42MzQsMCwwLDEsMCwuNDM5LjM3NS4zNzUsMCwwLDEsLjQzMSwwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC45NTggMCkgcm90YXRlKDQzKSIvPgogICAgPHBhdGggZD0iTS41MzcuNDI1LDQuMzg1LDBhLjM3NS4zNzUsMCwwLDEsLjQyOC40MzZoMEEuNjM0LjYzNCwwLDAsMSw0LjI4Ljk4TC40MzEsMS40QS4zNzUuMzc1LDAsMCwxLDAsLjk2N0gwQS42MzQuNjM0LDAsMCwxLC41MzcuNDI1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCA2LjczNykgcm90YXRlKC00MykiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };